import { createSlice } from '@reduxjs/toolkit'

const initialDashboardState = {
  dashboardList: [],
  dashboardId: null,
  tenMinTitleList: [],
  graphDataList: [],
  graphLabelListHandler: [],
  deviceListData: [],
  widgetOneGraphData: [],
  widgetId: null,
  widgetTypeId: null,
  widgetData: [],
  widgetXValue: null,
  widgetYValue: null,
  widgetWidthValue: null,
  widgetHeightValue: null,
  widgetSettingsData: {},
  saveDashboardFlag: false,
  widgetPositionSizeData: [],
  modalTypeRedux: '',
  hazmatDevice: '',
  hazmatLocation: '',
  hazmatLocationOption: [],
  deviceIdentifierData: [],
  deviceIdentifierValue: '',
  durationValue: null,
}

const dashboardSlice = createSlice({
  name: 'device',
  initialState: initialDashboardState,
  reducers: {
    dashboardListHandler(state, action) {
      state.dashboardList = action.payload
    },
    dashboardIdHandler(state, action) {
      state.dashboardId = action.payload
    },
    tenMinTitleListHandler(state, action) {
      state.tenMinTitleList = action.payload
    },
    graphDataListHandler(state, action) {
      state.graphDataList = action.payload
    },
    graphLabelListHandler(state, action) {
      state.graphLabelListHandler = action.payload
    },
    deviceListDataHandler(state, action) {
      state.deviceListData = action.payload
    },
    widgetOneGraphDataHandler(state, action) {
      state.widgetOneGraphData = action.payload
    },
    widgetIdHandler(state, action) {
      state.widgetId = action.payload
    },
    widgetDataHandler(state, action) {
      state.widgetData = action.payload
    },
    widgetXValueHandler(state, action) {
      state.widgetXValue = action.payload
    },
    widgetYValueHandler(state, action) {
      state.widgetYValue = action.payload
    },
    widgetWidthValueHandler(state, action) {
      state.widgetWidthValue = action.payload
    },
    widgetHeightValueHandler(state, action) {
      state.widgetHeightValue = action.payload
    },
    widgetTypeIdHandler(state, action) {
      state.widgetTypeId = action.payload
    },
    widgetSettingsDataHandler(state, action) {
      state.widgetSettingsData = action.payload
    },
    saveDashboardHandler(state, action) {
      state.saveDashboardFlag = action.payload
    },
    widgetPositionSizeDataHandler(state, action) {
      state.widgetPositionSizeData = action.payload
    },
    modalTypeHandler(state, action) {
      state.modalTypeRedux = action.payload
    },
    hazmatDeviceHandler(state, action) {
      state.hazmatDevice = action.payload
    },
    hazmatLocationHandler(state, action) {
      state.hazmatLocation = action.payload
    },
    hazmatLocationOptionHandler(state, action) {
      state.hazmatLocationOption = action.payload
    },

    deviceIdentifierDataHandler(state, action) {
      state.deviceIdentifierData = action.payload
    },
    deviceIdentifierValueHandler(state, action) {
      state.deviceIdentifierValue = action.payload
    },
    durationValueHandler(state, action) {
      state.durationValue = action.payload
    },
  },
})

export const dashboardActions = dashboardSlice.actions
export default dashboardSlice.reducer
